export const CREATE_TABLE = 'createTable';
